module.exports = __webpack_public_path__ + "img/tela-cheia.bb7b1f30.svg";